import useApi from '@/hooks/useApi';
import useInertiaData from '@/hooks/useInertiaData';
import React, { useEffect } from 'react';
import { DarkModeProvider } from '@/contexts/DarkModeContext';
import { Header, StaffSidebar } from './partials';

interface StaffLayoutProps {
    children: React.ReactNode;
}

const StaffLayout: React.FC<StaffLayoutProps> = ({ children }) => {
    const { user } = useInertiaData();
    const api = useApi();

    useEffect(() => {
        if (!user) {
            return;
        }

        const detectedTimezone =
            Intl.DateTimeFormat().resolvedOptions().timeZone;

        if (user.timezone !== detectedTimezone) {
            api.post('/api/update-timezone/', {
                timezone: detectedTimezone,
            }).catch((error) => {
                console.error('Failed to update timezone:', error);
            });
        }
    }, [user?.timezone, user, api]);

    return (
        <DarkModeProvider>
            <div className="flex min-h-screen bg-gray-50 dark:bg-neutral-900">
                <StaffSidebar />

                {/* Main Content */}
                <div className="flex min-w-0 flex-1 flex-col">
                    <Header />

                    {/* Main Content Area */}
                    <main className="flex-1 p-4 sm:p-6 lg:p-8">{children}</main>
                </div>
            </div>
        </DarkModeProvider>
    );
};

export default StaffLayout;
